const config = __CONFIG__

export default {
  AUTH_HEADER: 'Authorization',
  SHIPPER_HEADER: 'x-nv-shipper-id',
  LANGUAGE_HEADER: 'Accept-Language',
  SYSTEM_ID_HEADER: 'x-nv-system-id',
  REQUEST_ID_HEADER: 'x-nv-request-id',
  PROTECTION_KEY_HEADER: 'x-nv-digest',
  getAuth: token => `Bearer ${token}`,
  getBaseURL: ({ country = 'global', service }) => {
    if (config.ENVIRONMENT === 'local') {
      return `${config.BASE_URL}/`
    }
    return `${config.BASE_URL}/${country}/${service}/`
  }
}
